module.exports = __webpack_public_path__ + "img/VLADIM.802d6d69.png";